export const default_position = () => {
    return {
        id: null,
        code: null,
        name: null,
        description: null,
        wor_area_id: null,
        epps: [],
        exams: []
    };
};

export const default_params = () => {
    return {
        company_id: null,
        filter: null,
        paginate: 1,
        page: 1,
        per_page: 10
    };
};

export default {
    companies: [],
    areas: [],
    epps: [],
    exams: [],
    positions: {
        data: []
    },
    modal: {show: false},
    modal_upload: {show: false},
    position: default_position(),
    params: default_params(),
    editing: false,
    upload: {
        file: null
    }
};
